<template>
  <!--
    The shared page breadcrumb (first used on the agreement editor). Pass the trail as items: [{ title, to }].
    The first step carries the back arrow, every step but the last is a link, the last is the current page.
  -->
  <nav :class="['d-flex justify-end', { 'pointer-events-none': disabled }]" aria-label="Breadcrumb">
    <v-sheet color="brand-color-lightest" rounded="lg" class="border-thin d-inline-flex flex-wrap align-center ga-2 px-3 py-2">
      <!-- Phones show only the last two steps (the page to go back to, and the current page); the back arrow moves to the first one shown. -->
      <template v-for="(item, index) in items" :key="index">
        <v-icon v-if="index > 0" size="16" color="grey" aria-hidden="true"
          :class="{ 'd-none d-sm-inline-flex': index < items.length - 1 }">mdi-chevron-right</v-icon>
        <span v-if="index === items.length - 1" class="text-body-small font-weight-medium text-high-emphasis" aria-current="page">
          {{ item.title }}
        </span>
        <router-link v-else :to="item.to" :class="['align-center ga-1 text-body-small font-weight-semibold text-brand-color',
          index < items.length - 2 ? 'd-none d-sm-inline-flex' : 'd-inline-flex']">
          <v-icon v-if="index === 0" size="16" :class="{ 'd-none d-sm-inline-flex': items.length > 2 }">mdi-arrow-left-bottom</v-icon>
          <v-icon v-if="index > 0 && index === items.length - 2" size="16" class="d-sm-none">mdi-arrow-left-bottom</v-icon>{{ item.title }}
        </router-link>
      </template>
    </v-sheet>
  </nav>
</template>

<script setup>
defineProps({
  // [{ title, to }]; the last item is the current page and needs no `to`.
  items: {
    type: Array,
    required: true
  },
  // Locks the links, e.g. while a save is running.
  disabled: {
    type: Boolean,
    default: false
  }
})
</script>
